import { useMemo } from 'react';

import { useAccordianContext } from 'components/Accordian/context';
import { ChevronDown } from 'lucide-react';

export interface FAQHeaderProps {
  id: string;
  text: string;
}

const FAQHeader: React.FunctionComponent<FAQHeaderProps> = function ({
  id,
  text,
}) {
  const { openId } = useAccordianContext();
  const chevronClassName = useMemo(
    () =>
      ['transition-all', openId === id ? 'rotate-180' : '']
        .filter(Boolean)
        .join(' '),
    [openId, id],
  );

  return (
    <div className="p-4 md:px-6 flex flex-row justify-between gap-x-4 bg-neutral-000  transition-all">
      <p className="text-14-22-em text-neutral-800 text-left">{text}</p>
      <ChevronDown className={chevronClassName} />
    </div>
  );
};

export default FAQHeader;
